/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createPaginatedListOfAuditEntrySummaryFromDiscriminatorValue, createProblemDetailsFromDiscriminatorValue, type PaginatedListOfAuditEntrySummary, type ProblemDetails } from '../../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /customers/data-sharing-grants/{id}/auditentries
 */
export interface AuditentriesRequestBuilder extends BaseRequestBuilder<AuditentriesRequestBuilder> {
    /**
     * GetDataSharingGrantAuditEntries
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<PaginatedListOfAuditEntrySummary>}
     * @throws {ProblemDetails} error when the service returns a 400 status code
     * @throws {ProblemDetails} error when the service returns a 404 status code
     * @throws {ProblemDetails} error when the service returns a 409 status code
     */
     get(requestConfiguration?: RequestConfiguration<AuditentriesRequestBuilderGetQueryParameters> | undefined) : Promise<PaginatedListOfAuditEntrySummary | undefined>;
    /**
     * GetDataSharingGrantAuditEntries
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<AuditentriesRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
}
/**
 * GetDataSharingGrantAuditEntries
 */
export interface AuditentriesRequestBuilderGetQueryParameters {
    pageNumber?: number;
    pageSize?: number;
}
/**
 * Uri template for the request builder.
 */
export const AuditentriesRequestBuilderUriTemplate = "{+baseurl}/customers/data-sharing-grants/{id}/auditentries{?PageNumber*,PageSize*}";
/**
 * Mapper for query parameters from symbol name to serialization name represented as a constant.
 */
const AuditentriesRequestBuilderGetQueryParametersMapper: Record<string, string> = {
    "pageNumber": "PageNumber",
    "pageSize": "PageSize",
};
/**
 * Metadata for all the requests in the request builder.
 */
export const AuditentriesRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: AuditentriesRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createPaginatedListOfAuditEntrySummaryFromDiscriminatorValue,
        queryParametersMapper: AuditentriesRequestBuilderGetQueryParametersMapper,
    },
};
/* tslint:enable */
/* eslint-enable */
